module.exports = __webpack_public_path__ + "img/front_buttons_quantity.1a42362b.png";